import {  useState } from 'react';
import {obtenerActividades,ingresarActividad,obtenerActividad,actualizarActividad,deshabilitarActividad} from '../data/Actividades';
    
import { useContext } from "react";
import { AuthContext } from "auth";
import moment from 'moment';
import 'moment/locale/es';

export const useActividades= (actividadId) => {
    var {user}= useContext(AuthContext);

    const [actividades,setActividades]=useState();
    const [respuestaIngresarActividad, setRespuestaIngresarActividad] = useState({mensajeTexto:"",estado:false});

    const [actividadPorActualizar, setActividadPorActualizar] = useState({});
    const [respuestaActualizarActividad, setRespuestaActualizarActividad] = useState({mensajeTexto:"",estado:false});
    
    const updateRespuestaIngresarActividad=async =>{
        setTimeout(function() {
            setRespuestaIngresarActividad({mensajeTexto:"",estado:false});
        }, 4000);
    }
    const updateRespuestaActualizarActividad=async =>{
        setTimeout(function() {
            setRespuestaActualizarActividad({mensajeTexto:"",estado:false});
        }, 4000);
    }
    const getActividades= async() => {
        const respuesta=await obtenerActividades(user.Token);
        setActividades(respuesta)
    }
    const getActividad= async() => {
        const respuesta=await obtenerActividad(actividadId,user.Token);
        //console.log("actividad")
        //console.log(respuesta)
        setActividadPorActualizar(respuesta)
    }
  
    const insertActividad=async(ActividadPorIngresar)=>{
        
        if(ActividadPorIngresar!=null){
            const respuesta=await ingresarActividad(ActividadPorIngresar,user.Token);
            if(respuesta!=undefined)
            {
                setRespuestaIngresarActividad({estado:respuesta.success,mensajeTexto:respuesta.message})
            }
            else
            {
                setRespuestaIngresarActividad({estado:false,mensajeTexto:"Se produjo un error"})
            }
            
            return respuesta;
        }
    }
    const updateActividad=async(ActividadPorActualizar)=>{
        if(ActividadPorActualizar!=null){
            ActividadPorActualizar.ActividadId=actividadId;
            const respuesta=await actualizarActividad(ActividadPorActualizar,user.Token);
            if(respuesta!=undefined)
            {
                setRespuestaActualizarActividad({estado:respuesta.success,mensajeTexto:respuesta.message})
            }
            else
            {
                setRespuestaActualizarActividad({estado:false,mensajeTexto:"Se produjo un error"})
            }
            return respuesta;
        }
    }
    
    const disabledActividad=async(Id) =>{
        if(Id!=undefined && Id!=''){
            const respuesta=await deshabilitarActividad(Id,user.Token);
            //setDisable(true)
            return respuesta;
        }
    }
   
  
    return {
      
        actividades,
        getActividad,
        getActividades,
        updateRespuestaIngresarActividad,
        insertActividad,
        respuestaIngresarActividad,
        updateActividad,
        actividadPorActualizar,
        respuestaActualizarActividad,
        setActividadPorActualizar,
        updateRespuestaActualizarActividad,
        disabledActividad
               
       
    }
}
